/* @flow */

import { URLBuilder } from 'url-builder/url-builder';
import { Link } from 'lib/ui/link';

export class PostLink extends Link {
    constructor(post, urlBuilder = URLBuilder.defaultURLBuilder) {
        super({
            href: () =>
                urlBuilder.getUrl({
                    url: 'blog/slug',
                    value: {
                        slug: post.slug,
                    },
                }),
            label: () => post.title.rendered,
        });

        this.post = post;
    }
}
